<template lang="pug">
.new-size
  shForm(title="Nueva Talla")
</template>

<script>
import shForm from '@/components/pages/size/Form'

export default {
  name: 'NewSize',

  components: { shForm }
}
</script>

<style lang="stylus">
.new-size
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/size/New.vue